import { useEffect, useRef, useCallback } from 'react';

import composeRefs from './composeRefs';

export const CHECK_TIMEOUT = 300;

export const wrapMenuList = (MenuList) => {
  const WrappedMenuList = (props) => {
    const {
      selectProps: { handleScrolledToBottom, shouldLoadMore },
      innerRef,

      useEffect: useEffectProp,
      useRef: useRefProp,
      useCallback: useCallbackProp,

      setTimeout: setTimeoutProp,
      clearTimeout: clearTimeoutProp,
    } = props;

    const checkTimeoutRef = useRefProp(null);
    const menuListRef = useRefProp(null);

    const shouldHandle = useCallbackProp(() => {
      const el = menuListRef.current;

      // menu not rendered
      if (!el) {
        return false;
      }

      const { scrollTop, scrollHeight, clientHeight } = el;

      return shouldLoadMore(scrollHeight, clientHeight, scrollTop);
    }, [shouldLoadMore]);

    const checkAndHandle = useCallbackProp(() => {
      if (shouldHandle()) {
        if (handleScrolledToBottom) {
          handleScrolledToBottom();
        }
      }
    }, [shouldHandle, handleScrolledToBottom]);

    const setCheckAndHandleTimeout = useCallbackProp(() => {
      checkAndHandle();

      checkTimeoutRef.current = setTimeoutProp(setCheckAndHandleTimeout, CHECK_TIMEOUT);
    }, [checkAndHandle]);

    useEffectProp(() => {
      setCheckAndHandleTimeout();

      return () => {
        if (checkTimeoutRef.current) {
          clearTimeoutProp(checkTimeoutRef.current);
        }
      };
    }, []);

    return <MenuList {...props} innerRef={composeRefs(innerRef, menuListRef)} />;
  };

  WrappedMenuList.defaultProps = {
    useEffect,
    useRef,
    useCallback,
    setTimeout,
    clearTimeout,
  };

  return WrappedMenuList;
};
